import DevProdGuideImage from 'images/seamless-onboarding/dev-prod-guide.svg';
import BlogGoalsReportingImage from 'images/seamless-onboarding/blog-goals-reporting.svg';

export interface OnboardingCardConfig {
  id: string;
  title: string;
  description: string;
  additionalInfo: string;
  buttonText: string;
  imageSrc: string;
  imageAlt: string;
  gradientClasses: string;
}

export const ONBOARDING_CARDS: OnboardingCardConfig[] = [
  {
    id: 'automation',
    title: 'Boost Productivity with Automation',
    description:
      "Streamline your development process with workflow automations that eliminate friction across the SDLC - built to support your team's goals and best practices. This step is required for all use cases except Surveys.",
    additionalInfo:
      'By the end of this setup, gitStream will be running in the background, ready to track and power your automation journey.',
    buttonText: 'Enable Automations',
    imageSrc: BlogGoalsReportingImage,
    imageAlt: 'Boost Productivity with Automation',
    gradientClasses: 'bg-gradient-to-br from-green-200 to-emerald-300'
  },
  {
    id: 'survey',
    title: 'Run your first Survey',
    description:
      'Survey developers to scale feedback, compare perceived productivity to concrete reality, and justify DevEx investments to executive leadership.',
    additionalInfo:
      'Before launching your first survey, make sure your users are set up and ready to go.',
    buttonText: 'Create Survey',
    imageSrc: DevProdGuideImage,
    imageAlt: 'Run your first Survey',
    gradientClasses: 'bg-gradient-to-br from-gray-800 to-gray-900'
  }
];

export const DASHBOARD_CONTENT = {
  title: 'Welcome to LinearB!',
  subtitle: "Let's complete your initial setup"
};
